import types from './types';

export default {
  setCurrentRow(context, value) {
    context.commit(types.SET_CURRENT_ROW, value)
  },
  setTagsCounter(context, value) {
    context.commit(types.SET_TAGS_COUNTER, value)
  },
  setHasTickets(context, value) {
    context.commit(types.SET_HAS_TICKETS, value)
  },
}
